import { makeStyles } from "tss-react/mui"
import { tailwindPalette } from "../../../../theme/tailwindPalette"
import { PropsWithChildren } from "react"
import { FontAwesomeIcon, FontAwesomeIconProps } from "@fortawesome/react-fontawesome"
import { Badge, Box } from "@mui/material"

const useStyles = makeStyles()(() => ({
    header: {
        display: "flex",
        alignItems: "center",
        gap: "0.75rem",
    },
    iconContainer: {
        backgroundColor: tailwindPalette.blue[100],
        color: tailwindPalette.blue[400],
        borderRadius: "0.75rem",
        width: "2.5rem",
        height: "2.5rem",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
    },
    badge: {
        backgroundColor: tailwindPalette.slate[100],
        borderRadius: "50%",
        padding: "0.25rem 0.5rem",
        fontSize: "0.875rem",
        color: tailwindPalette.slate[500],
        fontWeight: 500,
    },
}))

export function DashboardSectionHeader({
    children,
    icon,
    badgeNumber,
}: PropsWithChildren<{ icon: FontAwesomeIconProps["icon"]; badgeNumber?: number }>) {
    const { classes } = useStyles()

    return (
        <Box className={classes.header}>
            <Box className={classes.iconContainer}>
                <FontAwesomeIcon icon={icon} />
            </Box>

            {children}

            {badgeNumber && badgeNumber > 0 && <Badge className={classes.badge}>{badgeNumber}</Badge>}
        </Box>
    )
}
